import React from 'react'
import GenericPullAndPushToolView from '../GenericPullAndPushToolView'
import RiskReconConfigListing from './RiskReconConfigListing'
import RiskReconCredentialsForm from './RiskReconCredentialsForm'

export default function RiskReconPullAndPushView(props) {
    return (
        <GenericPullAndPushToolView 
            {...props}
            PullCredentialForm={RiskReconCredentialsForm}
            PullConfigListingView={RiskReconConfigListing}
            RunOnDemandButtonText={'Sync tool applications'}
        />
    )
}